// Utilities Controller
// Handles utility operations like HTTP requests

import axios from 'axios';
import { toast as sonnerToast } from 'sonner';
import config from '../config.js';

/**
 * Make a POST request to the specified URL
 * @param {string} url - The endpoint URL to append to base_url
 * @param {Object} data - Data to send in the POST request
 * @returns {Promise} - Axios response promise
 */
export const post = async (url, data, isAuth = false) => {
    try {
        const response = await axios.post(`${config.base_url}/${url}`, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': isAuth ? `Bearer ${localStorage.getItem('token')}` : ''
            }
        });
        return response;
    } catch (error) {
        console.error('POST request failed:', error);
        console.error('Error response:', error.response?.data);
        console.error('Error status:', error.response?.status);

        // Handle expired/invalid token globally: show toast and clear session once
        try {
            const statusCode = error?.response?.status;
            const errorMessage = (error?.response?.data?.error || '').toString();
            const mentionsToken = errorMessage.toLowerCase().includes('token');

            if (statusCode === 401 && mentionsToken) {
                // Throttle to avoid spamming multiple toasts for concurrent requests
                if (typeof window !== 'undefined') {
                    if (!window.__authFailureNotified) {
                        window.__authFailureNotified = true;
                        // Reset the flag after a short delay to allow future notifications if needed
                        window.setTimeout(() => {
                            window.__authFailureNotified = false;
                        }, 30000);

                        try { localStorage.removeItem('token'); } catch (e) {}
                        try { localStorage.removeItem('globalFunctionalities'); } catch (e) {}
                        try { localStorage.removeItem('incubationAccess'); } catch (e) {}
                        try { localStorage.removeItem('functionalityNames'); } catch (e) {}
                        try { localStorage.removeItem('incubationIds'); } catch (e) {}
                        try { localStorage.removeItem('userAccess'); } catch (e) {}
                        try { localStorage.removeItem('currentUser'); } catch (e) {}

                        // Notify the user
                        sonnerToast.error('Session has expired. Please sign out and back in to continue.');
                    }
                }
            }
        } catch (_) {
            // Safely ignore any errors from the handler above
        }
        throw error;
    }
};

export default {
    post
};
